import * as React from 'react'
import { Card, Col, Flex, Row, Tag, Typography, theme } from 'antd'
import { CheckCircleOutlined, CloseSquareOutlined } from '@ant-design/icons'
import { Client, Manager } from '../../edit-v2/types'
import { path } from '../../../../libs'
import { formatMoney } from '../../../../libs/utils'

const { Text } = Typography

const isDefined = <T,>(value: T | undefined | null): value is T =>
  value !== undefined && value !== null

type Props = {
  className?: string
  client: Client | null
  manager: Manager | null
  loading?: boolean
  totalBalanceUSD: number
}

export const VerificationClientCard = ({
  client,
  className,
  loading,
  manager,
  totalBalanceUSD,
}: Props) => {
  const { token } = theme.useToken()

  return (
    <Card
      size="small"
      title={
        <Flex gap={8} align="center">
          Client card
          {client?.isPremium && (
            <Tag color="orange" bordered={false}>
              Premium
            </Tag>
          )}
          {client?.isTest && (
            <Tag color="error" bordered={false}>
              Test
            </Tag>
          )}
        </Flex>
      }
      className={className}
      loading={loading}
    >
      <Row gutter={[16, 8]}>
        {client?.clientId && (
          <Col>
            <Text strong>User ID: </Text>
            <a target="_blank" href={path.clients.details(client.clientId)}>
              {client.clientId}
            </a>
          </Col>
        )}
        {client?.fullName && (
          <Col>
            <Text strong>Full name: </Text>
            <Text>{client.fullName}</Text>
          </Col>
        )}
        {client?.email && (
          <Col>
            <Text strong>E-mail: </Text>
            <Text>{client.email}</Text>
          </Col>
        )}
        {isDefined(client?.verified) && (
          <Col>
            <Text strong>Is verified: </Text>
            <Tag color={client!.verified ? 'success' : 'error'}>
              {client!.verified ? 'Yes' : 'No'}
            </Tag>
          </Col>
        )}
        {isDefined(client?.partner) && (
          <Col>
            <Text strong>Is partner: </Text>
            <Tag color={client!.partner ? 'success' : 'error'}>
              {client!.partner ? 'Yes' : 'No'}
            </Tag>
          </Col>
        )}
        {isDefined(client?.hasDeposit) && (
          <Col>
            <Text strong>Has deposit: </Text>
            <Tag color={client!.hasDeposit ? 'success' : 'error'}>
              {client!.hasDeposit ? 'Yes' : 'No'}
            </Tag>
          </Col>
        )}
        {manager?.user?.email && (
          <Col>
            <strong>Manager:</strong> {manager.user.email}
          </Col>
        )}
        <Col
          style={
            totalBalanceUSD === 0
              ? { color: token.colorTextTertiary }
              : undefined
          }
        >
          <strong>Total balance USD:</strong>{' '}
          <span
            style={
              typeof totalBalanceUSD === 'number' && totalBalanceUSD > 0
                ? { color: token.colorSuccess, fontWeight: 700 }
                : undefined
            }
          >
            {formatMoney(totalBalanceUSD, 'USD')}
          </span>
        </Col>
      </Row>
    </Card>
  )
}
